/**
 * Prediction Engine V2 — Distribution Samplers
 *
 * Pure functions for sampling from statistical distributions.
 * Used by the Monte Carlo simulator.
 */

/**
 * Sample from a normal distribution using Box-Muller transform.
 * Used for: qualifying position, race position delta.
 */
export function sampleNormal(mean: number, stdDev: number): number {
  const u1 = Math.random();
  const u2 = Math.random();
  const z = Math.sqrt(-2 * Math.log(u1)) * Math.cos(2 * Math.PI * u2);
  return mean + stdDev * z;
}

/**
 * Sample from a Poisson distribution using inverse CDF.
 * Used for: overtake count (discrete, non-negative).
 */
export function samplePoisson(lambda: number): number {
  if (lambda <= 0) return 0;
  const L = Math.exp(-lambda);
  let k = 0;
  let p = 1;
  do {
    k++;
    p *= Math.random();
  } while (p > L);
  return k - 1;
}

/**
 * Sample from a Bernoulli distribution (coin flip with probability p).
 * Used for: DNF, fastest lap, DotD (yes/no events).
 */
export function sampleBernoulli(p: number): boolean {
  return Math.random() < p;
}

/** Clamp a value to [min, max]. */
export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}
